import { Grid, Segment, Header, Icon, Button, Card, Image as Img, Message } from "semantic-ui-react";
import React from "react";
import RadioButtons from "components/Form/RadioButtons";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import ScanContainer from "../scan/ScanContainer";

const schemaValidation = Yup.object().shape({
	result: Yup.string().required("Champ requis"),
});
const Result = ({ timer, hasScannedQR, result, checkQR, saveResult, setNotWaitingTimer, waitTimer, disabled, tube }) => {
	const getScanContainer = (checkQRcode) => {
		return (
			<div>
				<Message info content="Pour encoder le résultat du test, vous devez scanner le QR code du test terminé." />
				<ScanContainer
					close={() => (displayScanQR = false)}
					submit={checkQRcode}
					regex={new RegExp("^([0-9]{8}|[a-zA-Z][0-9]-[0-9]{2})$")}
					cardContent={
						<div
							style={{
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								flexWrap: "wrap",
								cursor: "pointer",
								position: "relative",
							}}
						>
							<Img
								floated="left"
								size="tiny"
								src={`${process.env.REACT_APP_BASE_URL}/tubePictos/${
									tube && tube.properties && tube.properties.picto ? tube.properties.picto.filename : "102.png"
								}`}
								style={{ margin: 0 }}
							/>
							<Card.Header style={{ width: "100%", textAlign: "center" }}>
								{tube && tube.properties ? tube.properties.label : "Position portoir"}
							</Card.Header>
						</div>
					}
				/>
			</div>
		);
	};

	let displayScanQR = false;
	return (
		<div>
			<Grid.Row columns={1} style={{ margin: -20 }}>
				<Grid.Column>
					<Segment>
						{disabled && (
							<>
								{result && (
									<div>
										<Icon name="check square outline" />
										Résultat du test : {result === "p" ? "positif" : result === "n" ? "négatif" : result === "i" ? "invalide" : ""}
									</div>
								)}
								{!result && <div style={{ textAlign: "center" }}>Il n'y a pas de résultat enregistré</div>}
							</>
						)}
						{!disabled && (
							<div>
								{timer === 0 && (
									<Message info content="Scannez tout d'abord, dans la section des tubes, le code-barres du test rapide pour démarrer le décompte." />
								)}
								{timer > -900 && timer < 0 && waitTimer && !result && (
									<div style={{ textAlign: "center" }}>
										<Message error content="Attendez la fin du décompte pour encoder le résultat." />
										{!displayScanQR && <Button basic size="small" content="Encoder" onClick={() => setNotWaitingTimer()} />}
									</div>
								)}
								{(timer < -900 || !waitTimer || result) && (
									<div>
										{!hasScannedQR && !result && (
											<div>
												<Segment>{getScanContainer(checkQR)}</Segment>
											</div>
										)}

										{(hasScannedQR || result) && !disabled && (
											<Formik
												enableReinitialize
												initialValues={{
													result: result || "",
												}}
												validationSchema={schemaValidation}
												onSubmit={(values) => {
													//update patient
													saveResult(values);
												}}
											>
												{({ submitForm, errors, touched, values, setFieldValue, dirty, handleReset }) => (
													<Form>
														<Segment placeholder>
															<Grid columns={2} stackable textAlign="center">
																<Grid.Row verticalAlign="middle">
																	<Grid.Column>
																		<fieldset
																			onMouseLeave={() => {
																				if (dirty && result !== values.result) {
																					submitForm();
																				}
																			}}
																		>
																			<Header icon>
																				<Icon name="check square outline" />
																				<RadioButtons
																					name="result"
																					field1={{ id: "p", customlabel: "Positif" }}
																					field2={{ id: "n", customlabel: "Négatif" }}
																					field3={{ id: "i", customlabel: "Invalide" }}
																					customlabel="Résultat du test"
																					values={values}
																					required
																				/>
																			</Header>
																		</fieldset>
																	</Grid.Column>
																</Grid.Row>
															</Grid>
														</Segment>
													</Form>
												)}
											</Formik>
										)}
									</div>
								)}
							</div>
						)}
					</Segment>
				</Grid.Column>
			</Grid.Row>
		</div>
	);
};

export default Result;
